<img alt="" [src]="srcImg" height="25" class="mr-5 p-1 h-[25px]" />
